// extracted by mini-css-extract-plugin
export default {"track":"carousel_track__paltv","scroll":"carousel_scroll__-aa3u"};